import * as React from 'react'
import MUIFormLabel from '@mui/material/FormLabel'

const FormLabel = (props) => <MUIFormLabel {...props} />

export default FormLabel
